'use strict';

import {element_exists} from "../functions";
import {
    fnErrorMsg,
    getSelectedCompany, printResponse, reloadVouchersTableWithMissingVoucherText,
    validateCompany
} from "../jquery-functions-library";

export var fnClosePeriod = function () {

    var btnClose = $('#btn-close-period');

    if (!element_exists(btnClose)) {
        return false;
    }

    btnClose.on('click', function (e) {

        console.log('btn-close-period');

        var company_id = getSelectedCompany();
        var data = {
            company_id: company_id
        };
        var lang = allLangFiles.vouchers.js;

        validateCompany(lang, {
                title: lang.period_title,
                content: lang.period_content,
                theme: 'supervan',
                columnClass: 'col-md-12',
                backgroundDismiss: true,
                buttons: {
                    Ja: {
                        action: function () {
                            $.ajax({
                                type: 'POST',
                                data: data,
                                url: '/voucher/close-period',
                                success: function (response) {

                                    printResponse(response);

                                    reloadVouchersTableWithMissingVoucherText();

                                    if (response.success !== undefined)
                                        $('.missing-vouchers-text').html(lang.period_text);
                                },
                                error: fnErrorMsg
                            });
                        },
                        text: lang.yes,
                    },
                    Nej: {text: lang.no},
                }
            }
        );
    });
};


